import React, { useState } from 'react';
import { history } from '../../../../../_helpers/history';
import { connect } from 'react-redux';
import { telehealthService as service } from '../../../../../_services/telehealth.service';
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

import moment from 'moment';
import AvailableOn from '../../../Schedule/Component/AvailableOn';
import ProviderOptions from './Components/ProviderOptions';
import LocationOptions from './Components/LocationOptions';
import ReactDatePicker from '../../../../../_components/DatePicker/ReactDatePicker';
import RenderValidateMessage from '../../../../../stories/Validation/RenderValidateMessage';

function RescheduleAction({ telehealth }) {
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [provider, setProvider] = useState(null);
  const [location, setLocation] = useState(null);
  const [availableOn, setAvailableOn] = useState(null);
  const [rescheduling, setRescheduling] = useState(false);
  const [appointmentDate, setAppointmentDate] = useState(null);

  const [failedMsg, setFailedMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleShow = () => {
    setProvider(telehealth.doctor.id)
    setLocation(telehealth.providerGroup.id)
    setAppointmentDate(moment(telehealth.appointmentDate.date).toDate())
    setAvailableOn(telehealth.availableOn ? moment(telehealth.availableOn.date).toDate() : null)
    setShow(true);
  }
  const handleClose = () => {
    setProvider(null);
    setLocation(null);
    setAppointmentDate(null);
    setAvailableOn(null);
    setShow(false);
  }

  const validate = (e) => {
    e.preventDefault();

    let errors = {};

    if (!appointmentDate) {
      errors.dateTime = 'Appointment Date is required.'
    } else if (moment(appointmentDate).isBefore(new Date())) {
      errors.dateTime = 'Appointment Date must be upcoming.';
    }

    if (!location) {
      errors.group = 'Location is required.'
    }

    if (!provider) {
      errors.provider = 'Provider is required.'
    }

    if (telehealth.status !== 'HOLD' && telehealth.status !== 'READY') {
      if (availableOn && moment(availableOn).isSameOrBefore(moment())) {
        errors.availableOn = 'Available On must be an upcoming date.';
      }

      if (availableOn && appointmentDate && moment(availableOn).isSameOrAfter(moment(appointmentDate))) {
        errors.availableOn = 'Available On must be before Appointment Date.';
      }
    }

    setErrors(errors);

    if (!errors.dateTime && !errors.provider && !errors.group && !errors.availableOn) {
      rescheduleTelehealth();
    }
  }

  const rescheduleTelehealth = () => {
    setRescheduling(true);
    setSuccessMsg('');
    setFailedMsg('');

    const availableOnFormat = availableOn ? moment(availableOn).format('YYYY-MM-DD HH:mm') : "";

    service.reschedule(telehealth, appointmentDate, provider, location, availableOnFormat)
      .then(() => {
        setRescheduling(false);
        setSuccessMsg('Telehealth appointment has been rescheduled.');

        setTimeout(() => {
          handleClose();
          history.go(0);
        }, 1500);
      })
      .catch(() => {
        setRescheduling(false);
        setFailedMsg('Could not reschedule the telehealth appointment. Please try again later.');
      });
  }

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Reschedule</Tooltip>}
    >
      <button
        title="Reschedule"
        onClick={handleShow}
        className="btn btn-outline-primary btn-sm">
        <i className="fas fa-edit"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule Telehealth</Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-0">
        {successMsg && <div className="alert alert-success mt-4">{successMsg}</div>}
        {failedMsg && <div className="alert alert-danger mt-4">{failedMsg}</div>}

        <form className="mt-4">
          <div className="form-group">
            <label><span className="text-danger">*</span> Location</label> &nbsp;
            <LocationOptions telehealth={telehealth} locationChanged={location => setLocation(location)} />
            <RenderValidateMessage errors={errors} field="group" />
          </div>
          <div className="form-group">
            <label><span className="text-danger">*</span> Provider</label> &nbsp;
            <ProviderOptions telehealth={telehealth} providerChanged={provider => setProvider(provider)} />
            <RenderValidateMessage errors={errors} field="provider" />
          </div>
          <div className="form-group">
            <label><span className="text-danger">*</span> Appointment Date</label> &nbsp;
            <ReactDatePicker
              selected={appointmentDate}
              onChange={(date) => { setAppointmentDate(date); }}
              minDate={new Date()}
              minTime={moment().set('hours', 6).set('minute', 0).toDate()}
              maxTime={moment().set('hours', 18).set('minute', 0).toDate()}
              showTimeSelect
              timeFormat="hh:mm aa"
              timeIntervals={5}
              timeCaption="Time"
              dateFormat="MMM d, yyyy h:mm aa"
              className="form-control"
              wrapperClassName="w-100"
            />
            <RenderValidateMessage errors={errors} field="dateTime" />
          </div>

          {telehealth.status !== 'READY' &&
            <div className="form-group">
              <AvailableOn
                sendOn={availableOn}
                setAvailableOn={(date) => setAvailableOn(date)}
                apptDate={appointmentDate}
                apptType={'telehealth'}
              />
              <RenderValidateMessage errors={errors} field="availableOn" />
            </div>
          }
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={validate}
          disabled={rescheduling}
          variant="primary"
        >
          {rescheduling ? 'Rescheduling...' : 'Reschedule'}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

const mapStateToProps = (state) => {
  return {
    availableOn: state.telehealth.current.availableOn,
  }
}

export default connect(mapStateToProps)(RescheduleAction);